import React, { useEffect, useState } from 'react';
import { OpenQuoteTableHeader } from './OpenQuoteTableHeader';
import Helper from 'src/helper/Helper';
import { useQuoteStore } from 'src/hooks/quote';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import RefreshStockButton from '../ProductListing/RefreshStockButton';
import Pagination from "src/component/Global/Pagination"
import NoResultContent from '../HomePageContent/NoResultContent';
import ReusableDiv from 'src/helper/ReusableDiv';
import stickyTableHeader from 'src/helper/stickyTableHeader';
import System from 'src/helper/system';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import { useProductStore } from 'src/hooks/product';
import Constants from 'src/helper/Constants';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import PriceTable from 'src/component/custom/PriceTable';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import getSymbolFromCurrency from "currency-symbol-map/currency-symbol-map";
import ProductInventoryDisplay from 'src/component/custom/ProductInventoryDisplay';
import useReduxState from 'src/hooks/useReduxState';

export function OpenQuoteListing() {
    const { noValue, siteUser: { CORE }, systemModules: { Quote } } = Constants
    const { avUserInfoData: { currentUser } } = System
    const [{ openQuoteList, isSuccessAction, openQuoteCount }, { get_open_quote_list }, { set_is_success_action }] = useQuoteStore();
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { get_inventory_params, get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
    const [{ productList }, { get_product_assets }, { }, { }] = useProductStore();
    const [inventoryLoader, setInventoryLoader] = useState(false);
    const [openQuoteListingLoader, setOpenQuoteListingLoader] = useState(true)
    const isCoreUser = currentUser === CORE
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: '',
        sortOrder: '',
        ascDesField: {}
    })
    const [deleteFlag, setDeleteFlag] = useReduxState(false, 'delectClicked')
    const setPageLimit = async (event) => {
        setListObj({ ...listObj, limit: Number(event.target.value), page: 1 });
        set_is_success_action(true)
    };

    useEffect(() => {
        setListObj({ ...listObj, pageCount: Math.ceil(openQuoteCount / listObj.limit) })
        window.scrollTo({ top: 0 });
        //added by ramya
        if(openQuoteList && Object.keys(openQuoteList).length) {
            let openQuoteArr = [];
            Object.entries(openQuoteList).map((data)=>{
                openQuoteArr.push(data[1])
            })
            localStorage.setItem("openQuotes",JSON.stringify(openQuoteArr)) 
        }
    }, [openQuoteList]);


    const fetchInventoryFromServer = async () => {
        const params = [];
        openQuoteList && Object.keys(openQuoteList).map((v, i) => {
            localStorage.setItem("openQuoteList",openQuoteList) //added by ramya
            const param = get_inventory_params(productList[openQuoteList[v].ItemNumber])
            if (param) {
                params.push(param)
            }
        })

        if (params && params.length) {
            await get_product_assets(params, { isPriceCall: false })
        }
    };

    useEffect(() => {
        const fetchHere = async () => {
            await get_open_quote_list({
                top: listObj.limit,
                skip: Helper.getSkipCount(listObj.page, listObj.limit),
                sortBy: listObj.sortBy,
                sortOrder: listObj.sortOrder
            });
            setOpenQuoteListingLoader(false)
        }
        if (isSuccessAction && deleteFlag === false) {
            fetchHere();
            set_is_success_action(false);
        } else if (isSuccessAction && deleteFlag === true) {
            setDeleteFlag(false)
            set_is_success_action(false);
            setListObj({
                pageCount: 0,
                page: 1,
                limit: 20,
                sortBy: '',
                sortOrder: '',
                ascDesField: {}
            })
            get_open_quote_list({
                top: 20,
                skip: 0,
                sortBy: "",
                sortOrder: ""
            });
        }
    }, [listObj.page, listObj.limit, listObj.sortBy, listObj.sortOrder, isSuccessAction, deleteFlag]);

    const refreshStock = async () => {
        setInventoryLoader(true)
        await fetchInventoryFromServer()
        setInventoryLoader(false)
    }

    const handlePageClick = async (data) => {
        setListObj({ ...listObj, page: (data.selected + 1) });
        set_is_success_action(true)
        Helper.scrollTop();
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC';
        } else {
            listObj.ascDesField[columnName] = 'ASC'
        }
        setListObj({ ...listObj, sortBy: columnName, sortOrder: listObj.ascDesField[columnName], ascDesField: listObj.ascDesField })
        set_is_success_action(true)
    };

    const getOrderByClass = (columnName) => {
        if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    useEffect(() => {
        let isDisplayFixedHeader;
        let refreshStockButton;
        let callback;

        if ((openQuoteList && openQuoteCount > 0)) {
            const sort = toggleOrderBy;
            const tableElement = document?.getElementById("openquotelisting-table");
            let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 156;

            // Admin Toolbar header height adjustment
            const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

            if (adminToolBarHeight > 0) {
                headerHeight = headerHeight + adminToolBarHeight;
            }
            // is used to track only one header will display at a moment
            // extra function attach 
            document.addEventListener("scroll", (ScrollEvent) => {
                // current table position from top
                const tablePosition = tableElement ? tableElement.getBoundingClientRect().y : false;
                const paginationPosition = document?.querySelectorAll("div.pagination-row") ? document?.querySelectorAll("div.pagination-row")[0]?.getBoundingClientRect()?.y : false;

                if (tablePosition && headerHeight > tablePosition && isNaN(paginationPosition) === false && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
                    // function used to display header clone after actual header height is less than headerHeight from top
                    // function(id, headerHeight,  tableContainerId, firstColumnsFixed, sort)
                    if (!document.getElementById("table_copy")) {
                        callback = stickyTableHeader("openquotelisting-table", headerHeight, "sticky-table-wrapper", 1, sort)
                        isDisplayFixedHeader = true;
                        refreshStockButton = document.getElementsByClassName("refresh-link")
                        refreshStockButton[refreshStockButton.length - 1].addEventListener("click", refreshStock);
                    }
                } else {
                    if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
                        // switch variable to false for track that clone header hide
                        isDisplayFixedHeader = false;
                        // check element exist before remove event listeners
                        if (refreshStockButton && refreshStockButton[refreshStockButton.length - 1] && refreshStock) {
                            refreshStockButton[refreshStockButton.length - 1]?.removeEventListener("click", refreshStock);
                        }
                        // function used to remove the clone header
                        if (Object.prototype.toString.call(callback) == '[object Function]') {
                            callback();
                        }
                    }
                }
            })

            return () => {
                if (callback) {
                    // switch variable to false for track that clone header hide
                    isDisplayFixedHeader = false;
                    // check element exist before remove event listeners
                    if (refreshStockButton && refreshStockButton[refreshStockButton.length - 1] && refreshStock) {
                        refreshStockButton[refreshStockButton.length - 1]?.removeEventListener("click", refreshStock);
                    }
                    // function used to remove the clone header
                    callback();
                    window.scrollTo(0, 0)
                }
            }
        }
    }, [openQuoteList, __check(['QUOTE_API_CALL']).status])

    const deleteQuotePopUp = (quote) => {
        System.popup('DeleteQuotePopup', { current_quote: quote })
    }

    const editQuotePopUp = (quote) => {
        System.popup('QuotePopup', {
            single_product: productList[quote.ERPPartNumber],
            current_quote: quote,
            addFrom: 'OpenQuoteListing',
            single_product_pricing_list: get_pricing_by_id({ uniqueId: quote.quoteLineItemId })
        })
    }

    return (
        <>
            {
                <div id="main" className="">
                    {ReusableDiv.QuoteHeader()}
                    <div id="pcnquote-page" className="pcn-page container">
                        <div className='sub-title mt-0'>My Open Quotes</div>
                        <p className='mb-4'>This is a collection of line items selected online, that has not been sent for quoting to the sales representative.</p>
                        <div className="content-box container api-request-content p-0 quote-tabs">
                            <OpenQuoteTableHeader />
                            <>
                                {openQuoteListingLoader ? <AxiosIndicatorRunTimeLoader /> :
                                    <div className='quote-tabs-content'>
                                        <div id="sticky-table-wrapper" className="table-responsive position-relative sticky-table-wrapper mx-3 pt-3 border-0">
                                            <div>
                                                {__check(['QUOTE_API_CALL'], { overlay: true }).render}
                                            </div>
                                            {(openQuoteList && openQuoteCount > 0) ?
                                                <>
                                                    <table id="openquotelisting-table" className="bs5 table table-bordered table-striped quotes-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="edit-quote-head" />
                                                                <th><span>Part Information</span>
                                                                    <span aria-label='PartNumber' className={'sort-container ' + getOrderByClass('PartNumber')}
                                                                        onClick={async () => { await toggleOrderBy('PartNumber') }}></span>
                                                                </th>
                                                                <th>
                                                                    <span>Quantity</span>
                                                                    <span aria-label='Quantity1' className={'sort-container ' + getOrderByClass('Quantity1')}
                                                                        onClick={async () => { await toggleOrderBy('Quantity1') }}>
                                                                    </span>
                                                                </th>
                                                                <th>Target Unit Price</th>
                                                                <th>Price</th>
                                                                <th>
                                                                    <div className='d-flex align-items-baseline justify-content-between'>
                                                                        <span>Availability</span>
                                                                        <RefreshStockButton fetchInventoryFromServer={async () => { refreshStock() }} label={'Refresh Stock'} />
                                                                    </div>
                                                                </th>
                                                                {/* <th> quote information </th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {Object.keys(openQuoteList).map((v, i) => (
                                                                <React.Fragment key={v}>
                                                                    {openQuoteList[v] &&
                                                                        <tr>
                                                                            <td>
                                                                                <div className="edit-quote-ic">
                                                                                    <a href={void (0)} data-toggle="modal" data-target="#delete-quote-Modal"
                                                                                        onClick={() => deleteQuotePopUp(openQuoteList[v])}><i className="fa fa-trash" /></a>
                                                                                    <a href={void (0)} className="text-blue" onClick={() => editQuotePopUp(openQuoteList[v])}><i className="fa fa-pencil" /></a>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="bs5 row">
                                                                                    <div className="col-12">Manufacturer:&nbsp;
                                                                                        {openQuoteList[v]?.ManufacturerName}
                                                                                    </div>

                                                                                </div>
                                                                                <div className="bs5 row">
                                                                                    <div className="col-12">Mfg Part #:&nbsp;
                                                                                        {productList[openQuoteList[v].ItemNumber] ?
                                                                                            <NavigateToProductDetail
                                                                                                data={{ ManufacturerName: openQuoteList[v]?.ManufacturerName, ERPMFRPartNumber: openQuoteList[v]?.ERPMFRPartNumber, ItemNumber: openQuoteList[v]?.ItemNumber, ERPPartNumber: openQuoteList[v]?.ERPPartNumber }}>
                                                                                                <div className="text-blue">
                                                                                                    <b>{openQuoteList[v]?.ERPMFRPartNumber}</b>
                                                                                                </div>
                                                                                            </NavigateToProductDetail>
                                                                                            :
                                                                                            openQuoteList[v]?.ERPMFRPartNumber
                                                                                        }
                                                                                    </div>
                                                                                </div>

                                                                                {isCoreUser && openQuoteList[v].customerPartNumber && openQuoteList[v].customerPartNumber.length > 1 &&
                                                                                    <>
                                                                                        <label className="mt-2"><b>Customer Part Number </b>

                                                                                        </label>
                                                                                        <div>
                                                                                            <div>{openQuoteList[v].customerPartNumber}</div>
                                                                                        </div>
                                                                                    </>
                                                                                }
                                                                            </td>
                                                                            <td>
                                                                                {/* <div>{openQuoteList[v].quantity1 > 0 ? System.getInventoryFormat({ quantity: openQuoteList[v].quantity1 }) : noValue}</div> */}
                                                                                <div>{openQuoteList[v].quantity1 > 0 ? System.getFormatNumber({ amount: openQuoteList[v].quantity1, maximumFractionDigits: 0, isSymbol: false, isDisplaySymbol: false }) : noValue}</div>
                                                                                {/* <div>{openQuoteList[v].quantity2 > 0 ? System.getInventoryFormat({ quantity: openQuoteList[v].quantity2 }) : noValue}</div> */}
                                                                                <div>{openQuoteList[v].quantity2 > 0 ? System.getFormatNumber({ amount: openQuoteList[v].quantity2, maximumFractionDigits: 0, isSymbol: false, isDisplaySymbol: false }) : noValue}</div>
                                                                                {/* <div>{openQuoteList[v].quantity3 > 0 ? System.getInventoryFormat({ quantity: openQuoteList[v].quantity3 }) : noValue}</div> */}
                                                                                <div>{openQuoteList[v].quantity3 > 0 ? System.getFormatNumber({ amount: openQuoteList[v].quantity3, maximumFractionDigits: 0, isSymbol: false, isDisplaySymbol: false }) : noValue}</div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="bs5 row">
                                                                                    <div className="col-6">
                                                                                        <div>
                                                                                            {(openQuoteList[v].targetUnitPrice && openQuoteList[v].targetUnitPrice > 0) ? System.getFormatNumber({ amount: openQuoteList[v].targetUnitPrice, currency: openQuoteList[v].targetCurrency }) : noValue}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-6 text-end">
                                                                                        {getSymbolFromCurrency(openQuoteList[v].targetCurrency)} {openQuoteList[v].targetCurrency}
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="price-table-list">
                                                                                    <PriceTable
                                                                                        isDisplayCPN={false}
                                                                                        single_product_pricing_list={get_pricing_by_id({ uniqueId: openQuoteList[v]?.quoteLineItemId })}
                                                                                        single_product_inventory={get_inventory_by_id(openQuoteList[v]?.ItemNumber)}
                                                                                        single_product={openQuoteList[v]}
                                                                                        from={Quote} />
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                {inventoryLoader ?
                                                                                    <AxiosIndicatorRunTimeLoader /> : <ProductInventoryDisplay single_product={productList[openQuoteList[v]?.ItemNumber]}
                                                                                        single_product_inventory={get_inventory_by_id(openQuoteList[v]?.ItemNumber)} />}
                                                                            </td>
                                                                        </tr>
                                                                    }
                                                                </React.Fragment>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                                                </>
                                                :
                                                <div className="mt-3">
                                                    <NoResultContent message={"There are no open quotes for this account"} isDisplay={false} />
                                                </div>
                                            }
                                        </div>
                                    </div>}
                            </>
                        </div>
                    </div>
                </div>
            }
        </>
    );

}
